import dynamic from 'next/dynamic'
import { createRef, Component } from 'react'
import InputImage from 'components/input-image/input-image'
import Btn from 'components/btn/btn'
import BtnGroup from 'components/btn-group/btn-group'
import Infoblock from 'components/infoblock/infoblock'
import { parseFormEvent } from 'utils/helpers'
import styles from './form.module.scss'

import Checkbox from 'components/input/checkbox/checkbox'
import Input from 'components/input/input/input'
import Select from 'components/input/select/select'
import Textarea from 'components/input/textarea/textarea'

const Courier = dynamic(() => import('components/input/courier/courier'))

export default class Form extends Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.inputo = createRef()
        for (var field of props.fields) {
            this.state[field.name] = field.value
        }
    }

    handleChange = e => {
        const { name, value } = parseFormEvent(e)
        this.setState({ ...this.state, [name]: value })
    }

    resetFields = () => {
        let newState = {}
        for (var field of this.props.fields) {
            newState[field.name] = field.value
        }
        this.setState({ ...newState })
    }

    submitHandler = e => {
        e.preventDefault()
        // if (!this.inputo.current.value) {
            this.props.onSubmit(this.state, e.target)
        // }
    }

    render() {
        const { error } = this.props

        return (
            <>
                <form onSubmit={this.submitHandler} className={styles.form}>
                    {this.props.images && (
                        <div className={styles.left}>
                            {this.props.images.map((field, k) => (
                                <InputImage
                                    key={k}
                                    value={field.value}
                                    name={field.name}
                                    onChange={this.handleChange}
                                    label={field.label}
                                    required={field.required}
                                />
                            ))}
                        </div>
                    )}
                    <div className={styles.right}>
                        <div className="mb48">
                            {this.props.extraElements}
                            {this.props.fields.map((field, k) => {
                                let Component
                                switch (field.type) {
                                    case 'textarea':
                                        Component = Textarea
                                        break
                                    case 'checkbox':
                                        Component = Checkbox
                                        break
                                    case 'select':
                                        Component = Select
                                        break
                                    case 'courier':
                                        Component = Courier
                                        break
                                    default:
                                        Component = Input
                                }
                                return (
                                    <Component
                                        key={k}
                                        type={field.type}
                                        name={field.name}
                                        minLength={field.minLength}
                                        options={field.options}
                                        value={this.state[field.name]}
                                        onChange={this.handleChange}
                                        label={field.label}
                                        info={field.info}
                                        content={field.content}
                                        required={field.required}
                                        noAsterisk={this.props.noAsterisk}
                                    />
                                )
                            })}
                        </div>
                        <label className={styles.inputo} tabIndex="-1" htmlFor="your_name"></label>
                        <input
                            ref={this.inputo}
                            className={styles.inputo}
                            tabIndex="-1"
                            autoComplete="off"
                            type="text"
                            role="presentation"
                            id="name"
                            name="your_name"
                            placeholder="Your name here"
                        />
                        <BtnGroup align={this.props.align} withBlanks={this.props.withBlanks}>
                            {this.props.extraButtons}
                            <Btn style="yellow" {...this.props.submitProps}>
                                {this.props.submitText || 'Pateikti'}
                            </Btn>
                        </BtnGroup>
                    </div>
                </form>
                {error && (
                    <Infoblock type="error" className="mt36">
                        {error}
                    </Infoblock>
                )}
            </>
        )
    }
}
